import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  List,
  ListItem,
  Link,
} from '@mui/material';

function UserAgreement() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '30px', paddingBottom: '30px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Conditions d'utilisation
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Toutes les données et jeux de données publiés par le Burundi sur ce portail de données accessibles, fourni par la Banque Africaine de Développement, sont sous la licence internationale 
          <em> Creative Commons Attribution 4.0</em> (
          <Link href="https://creativecommons.org/licenses/by/4.0/legalcode" target="_blank" rel="noopener">
            CC-BY 4.0
          </Link>
          ). L’Institut National de la Statistique du Burundi (INSBU) fournit aux utilisateurs un accès gratuit au portail, dans le respect des termes du présent accord et des conditions générales d'utilisation du site Web de l’INSBU (
          <Link href="https://www.insbu.bi" target="_blank" rel="noopener">
            https://www.insbu.bi
          </Link>
          ), qui sont incorporés dans les présentes conditions du portail. Bien que ce portail soit régi par la licence CC-BY 4.0, les conditions générales du site Web de l’INSBU s’appliquent également à ce portail. Dans le cas où les présentes conditions du portail s’opposeraient aux conditions générales, ces conditions devraient prévaloir. L'utilisation de données dérivées des jeux de données, présentées sous forme de tableaux et de graphiques, est également soumise à ces conditions.
        </Typography>

        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Octroi de Licence
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Les utilisateurs sont encouragés à utiliser les jeux de données sur ce site pour leur propre bien et celui des autres de manière créative. Ils sont autorisés à extraire, télécharger et créer des copies des données contenues dans les jeux de données, ainsi que de partager ces données avec des tiers dans les conditions d'utilisation décrites ci-dessous, tout en mentionnant la source des données.
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          En utilisant ou en téléchargeant les jeux de données sur les sites Web de l’INSBU, vous acceptez de vous conformer aux conditions générales d'une licence CC-BY 4.0, ainsi qu'aux conditions spécifiées de cette licence. L’INSBU accorde aux utilisateurs à travers le monde une liberté d'utilisation des données et des bases de données non exclusives et irrévocables, sans droits d'auteur, et sans possibilité de sous-licence, dans les conditions suivantes :
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          VOUS ÊTES LIBRES DE :
        </Typography>

        <Typography variant="h6" align="justify" style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Partage
        </Typography>
        <List>
          <ListItem>Copier et / ou redistribuer les données</ListItem>
        </List>

        <Typography variant="h6" align="justify" style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Reproduction
        </Typography>
        <List>
          <ListItem>
            "Reproduire" signifie réaliser des copies d’une œuvre par tout moyen, y compris, sans limitation, les enregistrements sonores ou visuels, ainsi que par le droit de fixation et de reproduction des fixations de l’œuvre, notamment le stockage d’une exécution protégée ou d’un phonogramme sous forme numérique ou autre support électronique.
          </ListItem>
        </List>

        <Typography variant="h6" align="justify" style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Œuvres Dérivées
        </Typography>
        <List>
          <ListItem>Créer ou produire des œuvres dérivées des données.</ListItem>
        </List>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          VOUS ÊTES OBLIGÉS DE :
        </Typography>

        <Typography variant="h6" align="justify" style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Attribution
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Les utilisateurs doivent attribuer toute utilisation publique de la base de données ou des travaux produits à partir de la base de données, à l’auteur et/ou au propriétaire du contenu protégé par le droit d'auteur, ce qui inclut l’ajout d’un lien vers la source des données. Cependant, les utilisateurs doivent indiquer clairement que le donneur de licence (l’INSBU) ne cautionne aucune œuvre résultante créée à partir des données.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          L'attribution doit être formatée de la manière suivante : <em>INSBU : Nom du jeu de données : Lien du jeu de données</em>.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Lors du partage ou de la facilitation de l'accès aux jeux de données, les utilisateurs doivent intégrer la même condition de reconnaissance dans toutes les sous-licences des données octroyées et exiger que les sous-licenciés fassent de même.
        </Typography>

        <Typography variant="h6" align="justify" style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Préavis
        </Typography>
        <List>
          <ListItem>
            Conservez les avis de copyright et de licence intacts. Pour toute utilisation ou redistribution de données ou d'œuvres produites à partir de la base de données, les utilisateurs doivent préciser la licence de la base de données et conserver intacts les droits d'auteur et les notifications figurant dans la base de données d'origine. Vous ne pouvez pas appliquer de termes juridiques ou de mesures techniques qui empêchent légalement d’autres personnes d’utiliser les données de la manière autorisée par cette licence.
          </ListItem>
        </List>

        <Typography variant="h6" align="justify" style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Changements d'État
        </Typography>
        <List>
          <ListItem>
            Les utilisateurs doivent indiquer dans leurs travaux les modifications qui ont été apportées au travail original sous licence de manière à permettre l'attribution.
          </ListItem>
        </List>

        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Informations supplémentaires
        </Typography>

        <Typography variant="h6" align="justify" style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Aucune approbation :
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Aucun élément de la présente licence publique ne peut constituer ni être interprété comme une autorisation de certifier ou de suggérer que vous ou que votre utilisation du matériel sous licence est liée, sponsorisée, approuvée ou s’est vu reconnaître un statut officiel par le Concédant (INSBU) ou toute autre personne désignée recevant l'attribution. L’INSBU se réserve le droit de poursuivre, dans le respect des lois, toute utilisation de nos jeux de données de manière à falsifier, fausser la représentation, dénigrer ou utiliser de manière frauduleuse les éléments fournis dans ces jeux de données.
        </Typography>

        <Typography variant="h6" align="justify" style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Confidentialité :
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          L’INSBU ne publiera pas d'informations privées ou confidentielles en tant que données ouvertes, ni aucune autre information ayant des implications sur la sécurité publique ou la sécurité nationale.
        </Typography>

        <Typography variant="h6" align="justify" style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Publication de données :
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Les données publiées sur cette plate-forme sont fournies dans des formats lisibles par l'homme et par l'ordinateur, avec une préférence pour les normes ouvertes afin d'encourager une réutilisation à grande échelle. L’INSBU confirme que toutes les données disponibles sur cette plate-forme sont maintenues et mises à jour à intervalles réguliers.
        </Typography>

        <Typography variant="h6" align="justify" style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Exclusion de responsabilité :
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          L'INSBU ne pourra être tenu responsable envers les utilisateurs de toute perte ou tout dommage, de quelque sorte qu'il soit, résultant de l'utilisation des jeux de données. L’INSBU ne doit pas non plus être tenue responsable de l'exactitude, de l’interprétation, de l'utilité ou de la disponibilité des données contenues dans les jeux de données.
        </Typography>

        <Typography variant="h6" align="justify" style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Autre :
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Veuillez consulter les conditions générales de l’INSBU avant d’utiliser ces jeux de données. Ceux-ci incluent les termes et conditions de l’INSBU par référence. En utilisant les portails de données ouvertes ou toute présentation de données qui en dérive, vous acceptez d’être lié aux conditions générales de l’INSBU, y compris les présentes conditions. L’INSBU peut modifier les présentes conditions à tout moment et à son unique discrétion.
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          <Link href="#_ftnref1" name="_ftn1">
            [1]
          </Link>
          Ici, le pays peut spécifier si les données peuvent être utilisées à des fins commerciales (revente).
        </Typography>
      </Container>
      <Footer />
    </div>
  );
}

export default UserAgreement;